<script>
	import Card from './Card.svelte'
	import Content from '../content/root.js'

	console.log(Content)

</script>

<style>
.App {
	margin: 30px 2%;
}

h1 {
	font-size: 32px;
	text-align: center;
	font-family: var(--font-heading);
	font-weight: normal;
	font-style: italic;
	margin-top: 0;
	margin-bottom: 30px;
}

.content {
	display: grid;	
	grid-column: auto;
	grid-column-gap: 15px;
	grid-row-gap: 30px;
}

@media (min-width: 800px) {
	.content {
		grid-template-columns: 1fr 1fr;
	}
}

@media (min-width: 1200px) {
	.content {
		grid-template-columns: 1fr 1fr 1fr;
	}
}

.references {
	font-size: 12px;
	text-align: center;
	margin: 30px 0;
	color: var(--colour-primary-l)
}

a {
	text-decoration: none;
	font-weight: bold;
	color: var(--colour-primary-l);
}

.highlight {
	background-color: var(--colour-secondary);
	padding: 2px 5px;
}
</style>

<div class="App">
	<h1>Form and <span class="highlight">Structure</span></h1>

	<div class="content">
		{#each Content.sort((a,b) => ('' + a.title).localeCompare(b.title)) as form}
			<div class="grid-sizing-wrapper">
				<Card data={form}/>
			</div>
		{/each}
	</div>
	<p class="references">
	Information from 
	<a href="https://www.writersdigest.com/whats-new/list-of-50-poetic-forms-for-poets">
		Writer's Digest
	</a>,
	<a href="http://www.shadowpoetry.com/">
		Shadow Poetry
	</a>,
	<a href="http://www.writeawriting.com/">
		Write A Writing
	</a>,
	<a href="http://www.poetrymagnumopus.com/">
		Poetry Magnum Opus
	</a>, and
	<a href="https://www.wikipedia.org/">
		Wikipedia
	</a>
	
</p>
</div>